import client from "./client";

export const login = ({ t_type, diag_t_id, name, grade, st_month }) =>
  client.post("/diagnosis/api/user", {
    t_type,
    diag_t_id,
    name,
    grade,
    st_month,
  });

export const setCookie = ({ token, is_middle }) =>
  client.post("/diagnosis/api/user", { token, is_middle });

export const check = () => client.get("/diagnosis/api/user");
